import lassoSelectPlugin from './lasso-select-plugin';

export default lassoSelectPlugin;
